import { Col, DatePicker, DatePickerProps, Input, Row, Select, Table } from "antd";
import { memo, useEffect, useMemo, useState } from "react";
import Search from "../../../../../Layout/search";
import { useAppSelector } from "../../../../../app/hooks";
import Label from "../../../../../Layout/Form/Label";
import { debounce } from "lodash";
import { useAsyncFn } from "react-use";

const TransactionHistory = () => {
  const dataReducer = useAppSelector((state) => state.screens.customer);
  const [state, setState] = useState<any>({
    data: [],
    count: 0,
    currentPage: 1,
  });
  const _onChangePage = async (page: number) => {
    setState({ ...state, currentPage: page });
  };
  useEffect(() => {
    if (dataReducer?.dataDetail?.orders) {
      setState({ data: dataReducer?.dataDetail?.orders });
    }
  }, [dataReducer]);
  const header: any = [
    {
      title: "STT",
      key: "id",
      dataIndex: "id",
      align: "center",
      render: (_text: string, record: any, index: number) => {
        return <>{index + 1}</>;
      },
    },
    {
      title: "Mã hợp đồng",
      key: "documentNo",
      dataIndex: "documentNo",
      align: "left",
    },
    {
      title: "Ngày giao dịch",
      key: "orderedAt",
      dataIndex: "orderedAt",
      align: "center",
      render: (_text: string, record: any, index: number) => {
        return <div>
          {(new Date(_text).toISOString().slice(0, 10).replace('T', ' ')).split("-").reverse().join("-")}
          {/* Should modify to formatDate() */}
          {/* {formatDate(record.updatedAt)} */}
        </div>
      },
    },
    {
      title: "Giá trị hợp đồng",
      key: "amount",
      dataIndex: "amount",
      align: "center",
      render: (_text: number, record: any, index: number) => {
        return new Intl.NumberFormat("de-DE").format(_text) + ' VND'
      },
    },
    {
      title: "Trạng thái",
      key: "status",
      dataIndex: "status",
      align: "center",
      render: (_text: string, record: any, index: number) => {
        return <div>
          {record.status === "CO" ? "Hoàn thành" : "Chưa hoàn thành"}
        </div>
      },
    },
  ];

  const StatusOptions = [
    { label: "Hoàn thành", value: "CO" },
    { label: "Chưa hoàn thành", value: "DR" },
  ];

  const [dataState, dataStateFn] = useAsyncFn(async (params: any) => {
    // return dispatch(getListCustomerAction(params) as any);
  });

  const debounceLoadData = useMemo(
    () =>
      debounce((query: any) => {
        return dataStateFn(query);
      }, 500),
    [dataStateFn]
  );

  const onChangeState = (query: any) => {
    setState(query);
    return debounceLoadData(query);
  };

  const onChangeValue = (value: any, propName: string) => {
  };

  const dateFormat = 'DD-MM-YYYY';

  return (
    <div className="p-2">
      <h3 className="text-xl bold pb-2 br-b">Thông tin giao dịch</h3>
      <Search>
        <div className="filter-box">
          <Row gutter={16}>
            {/* <Col xl={6}>
              <Label title="Mã hợp đồng" />
              <Input
                value={state.MaDoiTac}
                name={state.MaDoiTac}
                onChange={(e) =>
                  onChangeState({ ...state, MaDoiTac: e.target.value })
                }
              />
            </Col> */}
            <Col xl={6}>
              <Label title="Từ ngày" />
              <DatePicker className="w-full" format={dateFormat} placeholder={""} onChange={(value) => onChangeValue(value, `fromDate`)} />
            </Col>
            <Col xl={6}>
              <Label title="Đến ngày" />
              <DatePicker className="w-full" format={dateFormat} placeholder={""} onChange={(value) => onChangeValue(value, `toDate`)} />
            </Col>
            {/* <Col xl={6}>
              <Label title="Trạng thái" />
              <Select
                className="w-full"
                allowClear
                onChange={(name) => onChangeState({ ...state, LaNhanVien: name })}
                options={StatusOptions}
              />
            </Col> */}
          </Row>
        </div>
      </Search>
      <Table
        dataSource={state?.data || []}
        columns={header}
        pagination={{
          defaultPageSize: 10,
          total: state?.count || 0,
          showSizeChanger: false,
          onChange: _onChangePage,
        }}
        rowKey={"id"}
        bordered
      />
    </div>
  )
}

export default memo(TransactionHistory)